export const MEDIA_BREAKPOINTS = {
    MD_UP: window.matchMedia('(min-width: 48rem)'),
    LG_UP: window.matchMedia('(min-width: 64rem)'),
    XL_UP: window.matchMedia('(min-width: 75rem)'),
    XXL_UP: window.matchMedia('(min-width: 94.375rem)')
};
